// mixin.js
import Vue from "vue";
import Component from "vue-class-component";

type Timeout = ReturnType<typeof setTimeout>;

// You can declare a mixin as the same style as components.
@Component
export default class NowMixin extends Vue {
	now = new Date();
	timeoutHandle: Timeout | undefined = undefined;

	created() {
		this.startRegularTimeUpdating();
	}

	beforeDestroy() {
		clearTimeout(this.timeoutHandle as number | undefined);
	}

	startRegularTimeUpdating() {
		const that: NowMixin = this;
		that.timeoutHandle = setTimeout(async function () {
			that.now = new Date();
			that.startRegularTimeUpdating();
		}, 1000);
	}
}